import React from 'react';
import PropTypes from 'prop-types';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ImageHandler from '../../utils/ImageHandler';
import Markdown from '../Richtext/Markdown';
import Link from '../Global/Link';

// ====

// ====

const Hero = (props) => {
  const {
    title,
    image,
    align,
    color,
    backgroundColor,
    id,
    screen,
    size,
    video,
    videoTrigger,
  } = props;

  // ====

  return (
    <>
      <article
        id={id}
        className={`w-100 brand-hero ${size && `brand-hero-${size}`} ${
          video && `brand-hero-video`
        } ${image && title ? 'brand-hero-imagetitle' : ''}`}
      >
        <div
          className={`d-flex flex-column w-100 h-100 p-0 justify-content-center ${
            video ? 'align-items-end' : 'align-items-center'
          } `}
        >
          {image && (
            <img
              src={ImageHandler(image, '0x260')}
              className="brand-hero-logo"
              alt=""
            />
          )}
          {title && (
            <h1 className="brand-font brand-headline brand-headline-massive brand-headline-hero brand-headline-shadow brand-text-white">
              <Markdown>{title}</Markdown>
            </h1>
          )}
          {video && (
            <div
              className={`container brand-font-size-2 brand-link-white ${
                videoTrigger ? `text-center` : `text-left`
              }`}
            >
              <Link
                onClick={video}
                className="brand-hero-video-button"
                button={videoTrigger && true}
                icon={videoTrigger && 'play-circle'}
              >
                {videoTrigger ? (
                  videoTrigger
                ) : (
                  <FontAwesomeIcon icon="volume-mute" />
                )}
              </Link>
            </div>
          )}
        </div>
      </article>
    </>
  );
};

export default Hero;

// ====

Hero.propTypes = {
  id: PropTypes.string,
  title: PropTypes.string,
  screen: PropTypes.string,
  image: PropTypes.string,
  videoTrigger: PropTypes.string,
};

Hero.defaultProps = {
  id: null,
  title: null,
  screen: null,
  image: null,
  videoTrigger: null,
};
